import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  subContext: '',
};

export const initialGeneralState = {
  testGeneral: '',
};

export const initialMasterServicesState = {
  masterServicesList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditMasterService: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  deleteMasterService: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  categories: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialServicesState = {
  specialitiesList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditService: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  servicesList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  deleteService: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};
